import { produce } from 'immer' // TODO Move address to someting not specific to the basket?
import { ACTION } from './actions'
import { Address } from '../../basket/model/session/reducers'

/** *****************
 * Reducers
 ***************** */

export type Profile = {
  id: string | null
  firstName: string
  lastName: string
  companyName: string
  address: Address
  email: string
  phoneNumber: string
  vatNumber?: string | null
}

export type ProfileState = {
  data: Profile | null
  isLoading: boolean
}

const initialState: ProfileState = {
  data: null,
  isLoading: false,
}

export type PortalProfileEmailAddress = {
  emailId: string
  email: string
  isVerificationPending: boolean
  isPrimary: boolean
}

export type PortalProfileMobileNumber = {
  number: string
  isVerificationPending: boolean
}

export type PortalAddressId = string

export type PortalAddress = {
  countryCode: string
  postalCode: string
  city: string
  street: string
  houseNumber: string
  houseNumberSuffix: string
  suburb: string
  lines?: string[]
}

export type PortalProfileAddress = {
  addressId: PortalAddressId
  name: string
  isDefaultShippingAddress: boolean
  address: PortalAddress
  addressDetails: PortalProfileAddressDetails
}

export type PortalProfileAddressDetails = {
  firstName: string
  lastName: string
  companyName?: string
  vatNumber?: string
  email: string
  mobileNumber?: string | null
}
export type PortalProfileUserTypeConsumer = 'consumer'
export type PortalProfileUserTypeServicePoint = 'servicepoint'
export type PortalProfileUserTypeBusiness = 'business'

export type PortalProfileUserType =
  | PortalProfileUserTypeConsumer
  | PortalProfileUserTypeServicePoint
  | PortalProfileUserTypeBusiness

export type PortalProfile = {
  userId: string
  firstName: string
  lastName: string
  email: string
  emailAddresses: PortalProfileEmailAddress[]
  addresses: PortalProfileAddress[]
  mobilePhone: PortalProfileMobileNumber
  userType: PortalProfileUserType
}

// eslint-disable-next-line @typescript-eslint/default-param-last, @typescript-eslint/no-explicit-any
export const profileReducer = (state = initialState, action: any): ProfileState => {
  switch (action.type) {
    case ACTION.UPDATE_PROFILE_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }
    case ACTION.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case ACTION.UPDATE_PROFILE_SUCCESS:
      return {
        isLoading: false,
        data: action.payload.profile,
      }
    case ACTION.UPDATE_PROFILE_ADDRESS: {
      return produce<ProfileState>(state, (draft) => {
        if (draft.data) {
          // eslint-disable-next-line no-param-reassign
          draft.data.address = {
            ...draft.data.address,
            ...action.payload.address,
          }
        }
      })
    }
    case ACTION.UPDATE_PROFILE: {
      return produce<ProfileState>(state, (draft) => {
        if (draft.data) {
          // eslint-disable-next-line no-param-reassign
          draft.data = {
            ...draft.data,
            ...action.payload.profile,
          }
        }
      })
    }
    default: {
      return state
    }
  }
}

const isLoadingProfile = (state: ProfileState) => state.isLoading

const getProfile = (state: ProfileState) => state.data

/*

const getProfileAddressFormat = (state: ProfileState): AddressFormat => {
  const country = getCountryCodeByCurrentDomain()
  switch (country) {
    case 'ES':
      return {
        country: 'ES',
        lookupMode: LookupMode.ByPostalCode,
        fields: [
          {
            fieldName: FieldName.PostalCode,
            fieldKind: FieldKind.Required,
            pattern: /^\d{5}$/,
          },
          {
            fieldName: FieldName.HouseNumber,
            fieldKind: FieldKind.Required,
            pattern: /^[a-z0-9_]+$/,
          },
          {
            fieldName: FieldName.HouseNumberSuffix,
            fieldKind: FieldKind.Optional,
            pattern: null,
          },
          {
            fieldName: FieldName.Street,
            fieldKind: FieldKind.Autosuggest,
            strict: false,
          },
          {
            fieldName: FieldName.City,
            fieldKind: FieldKind.Autosuggest,
            strict: false,
          },
        ],
      }
    case 'PT':
      return {
        country: 'PT',
        lookupMode: LookupMode.ByPostalCode,
        fields: [
          {
            fieldName: FieldName.PostalCode,
            fieldKind: FieldKind.Required,
            pattern: /^\d{4}-\d{3}$/,
          },
          {
            fieldName: FieldName.HouseNumber,
            fieldKind: FieldKind.Required,
            pattern: /^[a-z0-9_]+$/,
          },
          {
            fieldName: FieldName.HouseNumberSuffix,
            fieldKind: FieldKind.Optional,
            pattern: null,
          },
          {
            fieldName: FieldName.Street,
            fieldKind: FieldKind.Autosuggest,
            strict: false,
          },
          {
            fieldName: FieldName.City,
            fieldKind: FieldKind.Autosuggest,
            strict: false,
          },
        ],
      }
    default:
      return {
        country: 'NL',
        lookupMode: LookupMode.ByPostalCodeAndHouseNumber,
        fields: [
          {
            fieldName: FieldName.PostalCode,
            fieldKind: FieldKind.Required,
            pattern: /^\d{4} ?[A-Z]{2}$/,
          },
          {
            fieldName: FieldName.HouseNumber,
            fieldKind: FieldKind.Required,
            pattern: /^[0-9]+$/,
          },
          {
            fieldName: FieldName.HouseNumberSuffix,
            fieldKind: FieldKind.Optional,
            pattern: null,
          },
          {
            fieldName: FieldName.Street,
            fieldKind: FieldKind.Autofilled,
          },
          {
            fieldName: FieldName.City,
            fieldKind: FieldKind.Autofilled,
          },
        ],
      }
  }
}

*/

export const profileSelectors = {
  isLoadingProfile,
  getProfile,
}
